import React, { Component } from 'react';
import { connect } from 'react-redux';
import { firebaseConnect } from 'react-redux-firebase';

import ReactAudioPlayer from 'react-audio-player';
import ReactRadioButtonGroup from 'react-radio-button-group';

import '../../../sass/components/ui-list';

import { keyedObjToArr } from '../../util/index';

class PupsquestMetricsPanelListItem extends Component {

    constructor (props) {
        super(props);

        this.state = {
            recording : this.props.recording,
            lesson: this.props.lesson
        };

        const { firebase: { storage } } = this.props;
        const storageRef = storage().ref();

        let audioRef = storageRef.child(this.props.recording.audio);
        audioRef.getDownloadURL().then( (response)=> {
            this.updateAudioSource(response);
        });
    }

    updateAudioSource (source) {
        this.setState({
            src: source
        });
    }

    calcAverage(lesson){
        let total = 0;
        let divisor = 0;

        lesson.reallyreading.forEach((item) =>{
            if(item.score === "-1" || item.score === "0"){
                return;
            }
            else if (item.score === "2"){
                total += 1;
            }
            divisor += 1;
        }, this);

        if (divisor == 0){
            return "";
        }
        return Math.round((total / divisor) * 100);
    }

    updateScore(value){
        let recording = this.state.recording;
        recording.score = value;
        let classroom = this.props.classroom.id;
        let student = this.props.student.id;
        let lesson = this.props.lesson;
        lesson.reallyreading1 = this.calcAverage(lesson);

        const { firebase } = this.props;
        firebase.set(`/classrooms/${classroom}/students/${student}/metrics/${lesson.id}`, lesson);

        this.props.updateAverage(lesson);

        this.setState({
            recording : recording
        });
    }

    render () {
        let isLoading = (!this.state.src);

		return (
		    <div className="ui-list">
                <div className="list-row">
                    {/* Audio Text */}
                    <div className="list-cell">
                        <h4>{this.props.count}. {this.state.recording.text}</h4>
                        {/* Grading */}
                        <div className="flex-grid">
                            <div className="col-4 align-left">
                                <ReactRadioButtonGroup
                                    options={[
                                        {
                                            value:'2',
                                            label:'Pass'
                                        },
                                        {
                                            value:'1',
                                            label:'Need Work',
                                            labelClassName:'need-work'
                                        },
                                        {
                                            value:'0',
                                            label:'Incorrect Audio'
                                        }
                                    ]}
                                    name={`score_${this.props.count}`}
                                    isStateful={true}
                                    value={`${this.state.recording.score}`}
                                    onChange={this.updateScore.bind(this)}
                                    groupClassName="radio-button-group"
                                />
                            </div>
                            {/* Audio Player */}
                            <div className="col-8 align-left">
                                {!isLoading ?
                                    (
                                        <ReactAudioPlayer
                                            src={this.state.src}
                                            controls={true}
                                        />
                                    ) : (
                                        <div className="loading-audio align-center">Loading Audio...</div>
                                    )
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
		);
	}
}


const fbWrappedComponent = firebaseConnect()(PupsquestMetricsPanelListItem);
export default connect(null, null)(fbWrappedComponent);




// WEBPACK FOOTER //
// ./js/components/PupsquestMetricsPanel/PupsquestMetricsPanelListItem.js